var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col w-full"},[_c('div',{staticClass:"grid grid-cols-12 gap-5"},_vm._l((_vm.widgets),function(widget,index){return _c('div',{key:'static_' + index,class:[
        {
          'md:col-span-6 lg:col-span-4': !_vm.isLarge(widget)
        },
        `shadow-sm col-span-12 `
      ]},[_c(_vm.getChartComponent(widget),{tag:"component",staticClass:"default",attrs:{"titlePosition":"lower","subtitle":widget.subtitle,"data":widget,"filteringEnabled":widget.filteringEnabled,"viewName":widget.viewName}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }